module.exports = __webpack_public_path__ + "static/media/carrossel-comentario-usuario-1.a5cac1c2.png";